import { render, staticRenderFns } from "./EllipseSolidIcon.vue?vue&type=template&id=5b2c26a4&"
import script from "./EllipseSolidIcon.vue?vue&type=script&lang=js&"
export * from "./EllipseSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports